import React from 'react';
import { Modal } from 'antd';
import {
  Container
} from './styles';
import CreateBlockTemplate from './CreateBlockTemplate';
import { withTranslation } from 'react-i18next';
import { CREATE_BLOCK_MODAL } from './translationValues';

const CreateBlockModal = props => {
  const { onSucess ,onCancel ,t } = props;
  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(CREATE_BLOCK_MODAL.CREATE_REUSABLE_SECTION_TITLE.key, CREATE_BLOCK_MODAL.CREATE_REUSABLE_SECTION_TITLE.value) }
        centered
        maskClosable={false}
        visible={true}
        width="625px"       
        footer={false}
        className="warning-modal"
        onCancel={onCancel}
      >
        <CreateBlockTemplate onSucess={onSucess} />
      </Modal>
    </Container>
  );
};
export default withTranslation(["CREATE_BLOCK_MODAL"])(CreateBlockModal);

